module.exports = __webpack_public_path__ + "img/overall-process.20975255.png";